const SportsIcon = () => {
  return (
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_130_1926)">
        <path
          d="M8.98046 5.08401H3.33984C2.7245 5.08401 2.22656 5.58194 2.22656 6.19728C2.22656 6.81263 2.7245 7.31057 3.33984 7.31057H8.98046C9.59585 7.31057 10.0938 6.81263 10.0938 6.19728C10.0938 5.58194 9.59585 5.08401 8.98046 5.08401ZM8.98046 13.9903H3.33984C2.7245 13.9903 2.22656 14.4882 2.22656 15.1035C2.22656 15.7189 2.7245 16.2168 3.33984 16.2168H8.98046C9.59585 16.2168 10.0938 15.7189 10.0938 15.1035C10.0938 14.4882 9.59585 13.9903 8.98046 13.9903ZM6.75391 9.53717H1.11329C0.497934 9.53717 0 10.0351 0 10.6504C0 11.2658 0.497934 11.7637 1.11329 11.7637H6.75391C7.36925 11.7637 7.86719 11.2658 7.86719 10.6504C7.86719 10.0351 7.36925 9.53717 6.75391 9.53717ZM35.7734 15.1035H29.0196V10.6504C29.0196 8.69504 26.6276 7.66548 25.218 9.07682L16.3124 17.9824C15.4427 18.8522 15.4427 20.2612 16.3124 21.1309L21.4179 26.2364L15.1991 32.4551C14.3294 33.3248 14.3294 34.7338 15.1991 35.6036C16.0689 36.4733 17.4779 36.4734 18.3477 35.6036L26.1407 27.8106C27.0104 26.9408 27.0104 25.5318 26.1407 24.6621L21.0352 19.5566L24.5664 16.0255V17.3301C24.5664 18.5597 25.5634 19.5566 26.7929 19.5566H35.7734C37.003 19.5566 38 18.5597 38 17.3301C38 16.1005 37.003 15.1035 35.7734 15.1035ZM20.7916 3.78814C19.9067 3.19996 18.7325 3.31633 17.9823 4.06646L11.8592 10.1895C10.9895 11.0593 10.9895 12.4682 11.8592 13.338C12.7291 14.2078 14.1381 14.2078 15.0078 13.3379L19.8404 8.50541L22.8965 11.4668L24.5664 10.0566C24.9302 9.69288 26.1753 8.64611 26.6446 8.42561L20.7916 3.78814Z"
          fill="#FF1818"
        />
        <path
          d="M16.8847 21.1153C16.3206 20.5511 16.5267 18.7118 16.3281 17.9609L1.83983 32.455C0.970057 33.3248 0.970057 34.7338 1.83983 35.6035C2.70953 36.4732 4.11857 36.4733 4.98834 35.6035L18.1094 22.7852L16.8847 21.1153Z"
          fill="#FF1818"
        />
        <path
          d="M30.1329 8.42383C31.9774 8.42383 33.4727 6.92853 33.4727 5.08398C33.4727 3.23944 31.9774 1.74414 30.1329 1.74414C28.2883 1.74414 26.793 3.23944 26.793 5.08398C26.793 6.92853 28.2883 8.42383 30.1329 8.42383Z"
          fill="#FF1818"
        />
      </g>
      <defs>
        <clipPath id="clip0_130_1926">
          <rect width="38" height="38" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SportsIcon;
